import { render, staticRenderFns } from "./vms-template-management.vue?vue&type=template&id=3dc2f854&"
import script from "./vms-template-management.vue?vue&type=script&lang=js&"
export * from "./vms-template-management.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports